export { default } from "/home/geees/kazungu/projects/website/fullstack/work/sisters_school/app/routes/account/signup/index.tsx";